import { Stack } from '@mantine/core';
import { useUnit } from 'effector-react';
import { paginationModel } from './model';
import { TicketsList } from './TicketList';
import { $ticketsFilter, TicketsFilter } from './TicketsFilter';

export const Tickets = () => {
    const filter = useUnit($ticketsFilter);

    return (
        <Stack gap='sm'>
            <TicketsFilter />
            <TicketsList
                paginationModel={paginationModel}
                filter={filter}
            />
        </Stack>
    );
};
